import React from "react";
import SidePanelLayout from "layouts/SidePanelLayout";
import AssetTransferFilter from "./AssetTransferFilter";
import AssetTransferPanel from "./AssetTransferPanel";

export default function AssetTransferList() {

    return (<>
        <SidePanelLayout
            sideComponent={AssetTransferFilter}
            mainComponent={AssetTransferPanel}>
        </SidePanelLayout>
    </>);

}
